import React from "react";
import GppMaybeOutlinedIcon from "@mui/icons-material/GppMaybeOutlined";
import profile from "../../../assets/img/fabicon.png";
import DropdownComponent from "../DropdownComponent";
import { useLocation } from "react-router-dom/cjs/react-router-dom";


const DefaultMessageScreen = ({
  selectedCompany,
  setSelectedCompany,
  selectedYear,
  setSelectedYear,
  selectedQuarter,
  setSelectedQuarter,
  summaryLoading,
  buttonStyle,
  handleSendMessage,
  tabValue,
  handleRadioChange,
  modelName,
  handleModelChange,
  questionTAB,
  handleExampleClick,
}) => {
  const location = useLocation(); // Get the current location object

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridGap: "1rem",
        }}
      >
        <div
          style={{
            fontSize: "34px",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img style={{ width: "50px" }} src={profile} alt="logo" />
        </div>

        <div
          style={{
            fontSize: "34px",
            fontWeight: "600",
            paddingLeft: "10px",
          }}
        >
          Hello again
        </div>
        <div style={{ paddingLeft: "10px" }}>
          Tell me what’s on your mind, or pick a suggestion.
        </div>

        <div className="human-reviewer-disclosure-banner">
          <div className="tooltip-icon">
            <GppMaybeOutlinedIcon sx={{ fontSize: "30px" }} />
          </div>
          <div className="message-container gmat-body-1">
            <div className="tooltip-content">
              While I can provide information about competitors, it's important
              to remember that I am an AI assistant and my knowledge may not be
              perfect. To ensure accuracy, it is recommend double-checking
              critical information with reliable sources <br /> This chatbot
              does not perform comparative analysis and lacks information for
              some of competitors on organic growth.
            </div>
          </div>
        </div>

        {/* // dropdown and radio button container starts */}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          {location.pathname === "/Generate-Summary" && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <DropdownComponent
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
                selectedQuarter={selectedQuarter}
                setSelectedQuarter={setSelectedQuarter}
              />
              {/* // generate summary button  */}
              <div
                style={{
                  marginTop: "20px",
                }}
              >
                {!summaryLoading ? (
                  <button
                    style={buttonStyle(
                      !(selectedCompany && selectedYear && selectedQuarter)
                    )}
                    onClick={() => handleSendMessage("summary")}
                    disabled={
                      !(selectedCompany && selectedYear && selectedQuarter)
                    }
                  >
                    Generate summary
                  </button>
                ) : (
                  <button
                    style={buttonStyle(
                      !(selectedCompany && selectedYear && selectedQuarter)
                    )}
                    disabled={true}
                  >
                    {" "}
                    Loading...{" "}
                  </button>
                )}
              </div>
            </div>
          )}

          {(location.pathname === "/" ||
            location.pathname === "/Generate-Summary") && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
              }}
            >
              {/* // tone  */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3px",
                }}
              >
                <div
                  style={{
                    paddingLeft: "10px",
                    display: "block",
                    fontWeight: "bold",
                  }}
                >
                  Select Tone
                </div>

                <div
                  style={{
                    paddingLeft: "10px",
                    display: "block",
                    gap: "10px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      value="sales_finance_office"
                      checked={tabValue === "sales_finance_office"}
                      onChange={handleRadioChange}
                    />
                    Sales Finance Office
                  </label>

                  <label
                    style={{
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      value="neutral"
                      checked={tabValue === "neutral"}
                      onChange={handleRadioChange}
                    />
                    Neutral
                  </label>
                </div>
              </div>

              {/* // model  */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3px",
                }}
              >
                <div
                  style={{
                    paddingLeft: "10px",
                    display: "block",
                    fontWeight: "bold",
                  }}
                >
                  Select Model
                </div>

                <div
                  style={{
                    paddingLeft: "10px",
                    display: "block",
                    gap: "10px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      value="gpt-4o"
                      checked={modelName === "gpt-4o"}
                      onChange={handleModelChange}
                    />
                    gpt-4o
                  </label>

                  <label
                    style={{
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      value="gpt-4o-mini "
                      checked={modelName === "gpt-4o-mini "}
                      onChange={handleModelChange}
                    />
                    gpt-4o-mini
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>

        {location.pathname === "/" && (
          <div
            style={{
              paddingLeft: "10px",
              fontWeight: "600",
              display: "grid",
              gap: "10px",
            }}
          >
            <span>Related frequently asked questions</span>

            <div className="newTabSelectDiv">
              {/* {tabValue === "price" ? (
                                            <>
                                              {pricetTAB.map((item, index) => (
                                                <div
                                                  className="click_item"
                                                  key={index}
                                                  onClick={() =>
                                                    handleExampleClick(
                                                      item.text
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <span>{item.text}</span>
                                                  </div>
                                                </div>
                                              ))}
                                            </>
                                          ) : (
                                            <>
                                              {otdTab.map((item, index) => (
                                                <div
                                                  key={index}
                                                  className="click_item"
                                                  onClick={() =>
                                                    handleExampleClick(
                                                      item.text
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <span>{item.text}</span>
                                                  </div>
                                                </div>
                                              ))}
                                            </>
                                          )}  */}
              <>
                {questionTAB.map((item, index) => (
                  <div
                    className="click_item"
                    key={index}
                    onClick={() => handleExampleClick(item.text)}
                  >
                    <div>
                      <span>{item.text}</span>
                    </div>
                  </div>
                ))}
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultMessageScreen;
